import React from "react";
import { injectIntl } from "react-intl";
import LetterTile from "./letter-tile.jsx";
import lodash from 'lodash'
import { Tinode } from "../tinode/tinode";
import { AppName } from '../config'

class NoMessage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.filterContactActive = this.filterContactActive.bind(this);
    this.getMemberLastMessage = this.getMemberLastMessage.bind(this);
    this.onChatNowClick = this.onChatNowClick.bind(this);
  }

  filterContactActive() {
    const { chatList } = this.props;
    return chatList.filter((v) => {
      return v?.public?.state > 0 && v?.private?.comment;
    });
  }

  getMemberLastMessage() {
    const { chatList } = this.props;
    return chatList.filter((c) => {
      return !!(c.latestMessage && c.latestMessage())
    });
  }

  onChatNowClick() {
    this.props.tinode.searchChatEditArea.focus()
  }

  render() {
    const { formatMessage } = this.props.intl;
    const listMember = this.filterContactActive();
    const listMemberShow = listMember.slice(0, 5);
    const listMemberLastMessage = this.getMemberLastMessage();
    return (
      <React.Fragment>
        {this.props.initCacheSuccess && this.props.search == Tinode.DEL_CHAR && listMemberLastMessage.length == 0 &&
          <div className="no-message">
            <div className="list-member">
              {listMemberShow.map((v) => {
                let avatar = lodash.has(v, 'public.photo.ref') ? v.public.photo.ref : true;
                return (
                  <div className="member">
                    <LetterTile
                      tinode={this.props.tinode}
                      avatar={avatar}
                      topic={this.props.tinode}
                      title={v.getTopicName()} />
                  </div>
                )
              })}
              {(listMember.length - 5 > 0) &&
                <div className="member member-last">
                  +{listMember.length - 5}
                </div>
              }
            </div>
            <div className="desc">
              {formatMessage({
                id: "no_message_desc",
                defaultMessage: "There are {member} people who can receive messages from {appName} application.",
              }, { member: <span> {listMember.length}</span>, appName: AppName })}
            </div>
            <div onClick={this.onChatNowClick} className="title">
              {formatMessage({
                id: "no_message_title",
                defaultMessage: "Chat now",
              })}
            </div>
          </div >
        }
      </React.Fragment>
    )
  }
}

export default injectIntl(NoMessage);